import { RestProvider } from '../../providers/rest/rest';
import { Component, Input, NgZone } from "@angular/core";
import { Events, IonicPage, NavParams, NavController, ModalController, AlertController, LoadingController, Platform, ToastController } from 'ionic-angular';
import { OrdersProvider } from '../../providers/orders/orders';
import { AuthProvider } from '../../providers/auth/auth';
import {FileUploader, FileUploaderOptions, ParsedResponseHeaders} from 'ng2-file-upload';
//import { LoginPage } from '../login-page/login-page';
import { Storage } from '@ionic/storage';
import { GlobalProvider } from "../../providers/global/global";
import moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
/**
 * Generated class for the OrdersPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage({
    segment: 'crm'
})
@Component({
  selector: 'page-crm',
  templateUrl: 'crm.html',
})
export class CrmPage {

	users: any;
	summary:any;
  stats:any;
	max_width:number = 100;

  search_Order_Id: string;
  search_User_Id: string;
  search_Status: any;
  search_Internal_Status: any;
  search_Image_Internal_Status:any;
  search_locale:any;
  filterToDate:any;
  filterFromDate:any;
  apply_date_on:string;
  sort_orders_created_by:any;
  search:string;
  searchField:string;
  limit:number;
  //Show full image quality size (publishable_file_url), else show thumb
  is_full_resolution:boolean;
  presentation_mode:boolean;


  public date: any;

  //Pagination
  res: any; //Pagination data
  // p: number = 1; //Pagination page
  //@Input('data') orders: string[] = [];
    //asyncMeals: Observable<string[]>;
    p: number = 1;
    per_page: number;
    total: number;

    descending: boolean = true;
   sortOrder: number;
   column: string = 'total_images';
   sort(column:string){
   	  this.column = column;
	  this.descending = !this.descending;
	  this.sortOrder = this.descending ? 1 : -1;
	}

    //loading: boolean;
    uploader: FileUploader;
    uploadImageType:any;
    forImageId:any;
    responses: Array<any>;
    imageSwatch:any;
    hasBaseDropZoneOver: boolean;

    mailingList = [];
    menu:boolean = false;

  loader: boolean;
  loading: any;
	errorMessage: string;
  public devWidth = this.platform.width(); //returns screensize

  constructor(public navCtrl: NavController, public navParams: NavParams, public rest: RestProvider, 
    public orderService: OrdersProvider, public modalCtrl: ModalController,
    public alertCtrl: AlertController, public authService: AuthProvider, public loadingCtrl: LoadingController, 
    public platform: Platform, public toastCtrl: ToastController, public storage: Storage ,
    public global: GlobalProvider, private zone: NgZone, public events: Events, public translate: TranslateService) {
  	this.date = moment();
  }

  resetSearchFilters(){
    this.search = '';
    this.search_Status = 'all';
    this.search_Internal_Status = 'all';
    this.search_locale = 'all';
    this.apply_date_on = 'all';
    this.filterFromDate = '';
	this.filterToDate = '';

  }

  toggleMenu(ev){
  	this.events.publish('menu:toggle', ev.checked);
  }




  setSearchFilter(type:string){

    this.resetSearchFilters();

    if (type == 'orders_need_approval') {
      this.search_Internal_Status = 20;
    }

    if (type == 'orders_need_spec_translation') {
      this.search_Internal_Status = 10;
    }

    if (type == 'orders_in_production') {
      this.search_Status = 50;
      this.search_Internal_Status = 100;
    }

    if (type == 'orders_complete') {
      this.search_Status = 100;
      this.search_Internal_Status = 100;
      console.log(this.search_Status, this.search_Internal_Status);
    }

    if (type == 'coupon_eligible') {

	let today = new Date();  	
	let from = moment.utc(today).subtract(40, 'd').format('YYYY-MM-D');
	let to = moment.utc(today).subtract(10, 'd').format('YYYY-MM-D');

	this.filterFromDate = from;
	this.filterToDate = to;
	this.apply_date_on = 'user';
	this.search_Status = 'all';
	this.search_Internal_Status = 'all';
	this.search_locale = 'de';

	this.fireToast("Filter date ON:  " + this.apply_date_on + "  Days created_at from : " + this.filterFromDate + " - " + this.filterToDate);
    }

    this.getPage(1);
   
  }




  ionViewDidLoad() {

    this.responses = [];

    // Default order created_at sort order
    this.sort_orders_created_by = 'desc';
    this.sort_orders_created_by = 'all';
    this.apply_date_on = 'all';

    const filterOrderId = this.navParams.get('orderId');
    const filterUserId = this.navParams.get('userId');
    if(filterOrderId){
      this.search = filterOrderId;
      this.searchField = 'orders.id';
    }else{
      if(filterUserId){
        this.search = filterUserId;
      }
      // Drfault search or order_id
      this.searchField = 'id';
    }
   

    
    this.limit = 100;
    
    this.getPage(1);

    


    //this.getOrders();
    //console.log("Orders:");
    //console.log(this.orders);
  }

  createBankTransferInvoice(user){
    let alert = this.alertCtrl.create();
    alert.setTitle('Enter EURO Amount:');

    alert.addInput({
      type: 'number',
      label: 'Payment amount',
      name: 'amount',
      placeholder: "Amount EUR"
    });

    alert.addInput({
      type: 'password',
      label: 'PW',
      name: 'PW',
      placeholder: "PW"
    });

    alert.addButton('Cancel');
    alert.addButton({
      text: 'Create',
      handler: inputData => {
        console.log('Create invoice with amount:', inputData);
        this.showLoader();
        this.orderService.createBankTransferInvoice(user.id, inputData).then((data: any) => {
            console.log('DATAA from createBankTransferInvoice:', data);

              const payment = data.data.payment;
              const new_balance = data.data.new_balance;

              user.balance_left = new_balance;
              user.payments.push(payment);


              this.fireAlert(data.message);
              if(this.loading){ this.loading.dismiss(); this.loading = undefined };
        }, (err) => {
             if(this.loading){ this.loading.dismiss(); this.loading = undefined };
              console.log("Error in Order completion", err);
              this.fireToast(err.json().message);
        });
      }
    });
    alert.present();
  }

  refreshOrders() {
    this.getPage(1);
  }

  searchEnter(ev){
  	this.getPage(1);
  }

   show_all_orders:boolean;
  show_orders_toggle:boolean;
  toggleShowOrders(user){
  	user.show_orders_toggle = (user.show_orders_toggle) ? false : true;
    //this.show_orders_toggle = (this.show_orders_toggle) ? false : true;
  }


  toggleAdditionalInfo(user){
  	user.show_add_info_toggle = (user.show_add_info_toggle) ? false : true;
  }

  promptForImageDownload(image:any){
  	let alert = this.alertCtrl.create();
    alert.setTitle('Which image do you want to download ?');

    if(image.file_url){
    alert.addInput({
      type: 'checkbox',
      label: 'Processed Raw',
      value: image.file_url,
      checked: true
    });
    }

    if(image.original_file_url){
    alert.addInput({
      type: 'checkbox',
      label: 'Original',
      value: image.original_file_url,
      checked: true
    });
    }

    if(image.publishable_file_url){
    alert.addInput({
      type: 'checkbox',
      label: 'Publishable',
      value: image.publishable_file_url,
      checked: true
    });
    }

    if(image.image_swatches){
    	for (var _i = 0; _i < image.image_swatches.length; _i++){
    		if(image.image_swatches[_i].publishable_file_url){
			    alert.addInput({
			      type: 'checkbox',
			      label: 'Publishable Swatch' + _i,
			      value: image.image_swatches[_i].publishable_file_url,
			      checked: true
			    });
			}
			if(image.image_swatches[_i].file_url){
			    alert.addInput({
			      type: 'checkbox',
			      label: 'Processed Raw Swatch' + _i,
			      value: image.image_swatches[_i].file_url,
			      checked: true
			    });
			}
    	}
    }

    alert.addButton('Cancel');
    alert.addButton({
      text: 'Download',
      handler: selected => {
        console.log('Selected urls:', selected);
        for (let url of selected){
        	window.open(url, '_blank');
        }
      }
    });
    alert.present();
  
  }

  getPage(page: number) {
    let searchOrderId = this.search_Order_Id;

    this.showLoader();

    if(this.filterFromDate || this.filterToDate){
    	this.fireToast("Filter date ON:  " + this.apply_date_on + "  Daterange: " + this.filterFromDate + " - " + this.filterToDate);
    }

    this.orderService.getCrm(page, searchOrderId, this.search_Status, this.search_Internal_Status, this.sort_orders_created_by, this.search, this.searchField, this.limit, this.search_Image_Internal_Status, this.search_locale, this.filterFromDate, this.filterToDate, this.apply_date_on).then((data: any) => {
        console.log('DATAA from Page:', data.users);
          this.res = data.users;

          this.users = data.users.data;
          this.summary = data.summary;

          //Add additional data
   //        this.users.forEach((user,index)=>{
			//   user=this.func(user,index);
			//   console.log("RETURNED USER!!");
			//   console.log(user);
			// })

			
          

          this.total = this.res.total;
          this.per_page = this.res.per_page;
          this.p = this.res.current_page;

          const perPage = 10;
          const start = (page - 1) * perPage;
          const end = start + perPage;

          if(this.loading){ this.loading.dismiss(); this.loading = undefined };
          this.closeSimpleLoader();

          this.getStreamStats();

    }, (err) => {
        if(this.loading){ this.loading.dismiss(); this.loading = undefined };
        this.closeSimpleLoader();
        this.fireToast(err.json().message);
        console.log("not allowed_____");
        console.log(err);
    });


    }



  getStreamStats() {
 
    this.orderService.getStreamStats().then((data: any) => {
        console.log('DATAA from getStreamStats:', data);

          this.stats = data;
          

    }, (err) => {

        this.fireToast(err.json().message);
        console.log("not allowed_____");
        console.log(err);
    });


    }

  formatUTC(date){
    return moment.utc(date).local().format('D.MM.YYYY');
  }

  formatUTCTimestamp(date){
  	let form = new Date(date*1000)
    return moment.utc(form).local().format('D.MM.YYYY');
  }

  pageChanged(event){
    this.getPage(event);
  }

  openTranslateRejections() {
    this.navCtrl.push('TransRejectionPage')
  }

  fireCompleteOrderNotification() {
    this.fireToast("Looks like all images have been completed. Please don't forget to press the 'Complete' button");
  }

  saveSpecsTranslation(order){
    // this.orderService.completePreProcessing(order).then((data: any) => {
    //     console.log('DATAA from COMPLETE ORDER:', data);
    //       this.fireToast(data.message);
    //       let index = this.orders.findIndex(item => item.id == order.id);
    //       if(index > -1){
    //         //Remove locally
    //           this.orders.splice(index, 1);
    //       }     
    // }, (err) => {
    //     console.log("Error in Order completion", err);
    //     this.fireToast(err.json().message);
    // });
  }


  // blockOrder(order){
  //                   this.orderService.blockOrder(order).then((data: any) => {
  //                       console.log('DATAA from COMPLETE ORDER:', data);
  //                         this.fireToast(data.message);
  //                         this.orders[0].is_blocked_by_admin = true;

  //                   }, (err) => {
                        
  //                       console.log("Error in Order completion", err);
  //                       this.fireToast(err.json().message);
  //                   });
  // }

  completeOrder(order){

     let prompt = this.alertCtrl.create({
      title: "Complete order",
      message: "All images done ? Order will disappear from backend after completion.",
      buttons: [
        {
          text: "Cancel"
        },
        {
          text: "Complete",
          handler: complete => { 
                    this.showLoader();
                    this.orderService.completeOrder(order).then((data: any) => {
                        console.log('DATAA from COMPLETE ORDER:', data);
                          this.fireToast(data.message);
                          if(this.loading){ this.loading.dismiss(); this.loading = undefined };
                          this.getPage(1);

                    }, (err) => {
                        if(this.loading){ this.loading.dismiss(); this.loading = undefined };
                        console.log("Error in Order completion", err);
                        this.fireToast(err.json().message);
                    });
          }
        }
      ]
    });
 
    prompt.present();



    



  }

  setMaxWidth(max_width:number){
  	if(max_width > 600){
  		this.menu = true;
  		this.events.publish('menu:toggle', true);
  	}else{
  		this.menu = false;
  		this.events.publish('menu:toggle', false);
  	}

  	this.max_width = max_width;
  }

  getStatsBadgeColor(val:number){
    if (val > 0) {
      return 'danger';
    }
    return 'secondary';
  }

  getInternalStatusColor(status: number) {
    if(status == 100){ // Ready, but delivery failed
      return 's_light_green';
    }
    if(status == 50){
      return 'danger';
    }
    return 'primary';
    
  }
  selectedAll: any;
  checkIfAllUsersSelected() {
  	console.log("Run check");
    this.selectedAll = this.users.every(function(item:any) {
        return item.checked == true;
      })
  }

  selectAllUsers(){
      for (var i = 0; i < this.users.length; i++) {
          this.users[i].checked = this.selectedAll;
       }
      // for(let image of selectedImages){
      //                    this.initImageDelete(image);
      //                 }
  }

  testChecked(){
  	let usertest = this.getSelectedUsers();
  	console.log("USERTEST", usertest);
  }

  getSelectedUsers() { 
    return this.users
              .filter(opt => opt.checked)
              .map(opt => opt)
  }

  getStatusColor(status: number) {
    if(status == 110){ // Ready, but delivery failed
      return 'dark';
    }
    if(status == 100){
      return 's_light_green';
    }
    if(status == 50){ // In Production
      return 'light';
    }
    if(status == 40){ //Waiting for payment
      return 'danger';
    }
    if(status == 10){ //Ready for production
      return 'orange';
    }
    if(status == 500){ // Archived
      return 'primary';
    }
    
    return 'primary';
    
  }

  operatorRejectOrder(order:any){
  	console.log("Reject order:", order);
  	let prompt = this.alertCtrl.create({
      title: "Order had rejections by operator",
      message: "Are you sure ? Job will be send back into prodution",
      buttons: [
        {
          text: "Cancel"
        },
        {
          text: "Reject",
          handler: rejection => {
 				console.log("REJECTION:", rejection);
                    this.showLoader();
                    this.orderService.rejectOperatorOrder(order).then((result: any) => {
                        if(this.loading){ this.loading.dismiss(); this.loading = undefined };
                        this.fireToast(result.message);

                        //Update locally
                         let index = this.users.orders.findIndex(item => item.id == order.id);
                          console.log("INDEX OF Order:", index);                       
				            if(index > -1){
				            	//Remove locally
				                this.users.orders.splice(index, 1);
				                
				            }     
                        
                    }, (err) => {
                        if(this.loading){ this.loading.dismiss(); this.loading = undefined };
                        this.fireAlert(err.json().message);
                        console.log("not allowed");
                    }); 
 
          }
        }
      ]
    });
 
    prompt.present();
  }

  operatorApproveOrder(order:any){
  	console.log("Approve order:", order);
  	this.showLoader();
    this.orderService.approveOperatorOrder(order).then((result: any) => {
        if(this.loading){ this.loading.dismiss(); this.loading = undefined };
        this.fireToast(result.message);

        //Update locally
         let index = this.users.orders.findIndex(item => item.id == order.id);
          console.log("INDEX OF Order:", index);                       
            if(index > -1){
            	//Remove locally
                this.users.orders.splice(index, 1);
                
            }     
        
    }, (err) => {
        if(this.loading){ this.loading.dismiss(); this.loading = undefined };
        this.fireAlert(err.json().message);
        console.log("not allowed");
    }); 
  }


  sendMail(type:string, user:any){
  	this.mailingList = [];

  	if (user) {
  		user.orders = [];
  		user.payments = [];
  		user.connectors = [];
  		user.templates = [];
  		console.log("User", user);
  		this.mailingList.push(user);
  	}else{
  		//Push all selected into list
  		let selected = this.getSelectedUsers();
  		for (var i = selected.length - 1; i >= 0; i--) {
  			console.log("SELECTED", selected[i]);
  			let usr = selected[i];
  			usr.orders = [];
  			usr.payments = [];
  			usr.connectors = [];
  			usr.templates = [];
  			this.mailingList.push(selected[i]);
  		}
  		
  	}

  	if (this.mailingList.length == 0) {
  		this.fireAlert("No users selected!");
  		return 'ok';
  	}
  	
  	this.fireSendMails(type);
  }


  fireSendMails(type){
  	let prompt = this.alertCtrl.create({
      title: "Send email to customers",
      message: "Type: " + type + ". Are you sure ?",
      buttons: [
        {
          text: "Cancel"
        },
        {
          text: "Send",
          handler: rejection => {
                    this.showLoader();
                    this.orderService.sendMailsForUserList(this.mailingList, type).then((result: any) => {
                        if(this.loading){ this.loading.dismiss(); this.loading = undefined };
                        this.fireToast(result.message);

                        //Update locally
             //            let image = result.data; 
                        
             //             let index = order.images.findIndex(item => item.id == image.id);
             //              console.log("INDEX OF IMAGE:", index);                       
				         //    if(index > -1){
				         //    	//Remove locally
				         //        //order.images.splice(index, 1);
				                
				         //        // Update locally
				         //        order.images[index] = image;
				                
				         //    }     

				         // // Update order locally
				         // let index2 = this.orders.findIndex(item => item.id == order.id);
				         // console.log("INDEX of ORDER:", index2);
				         // if (index2 !== -1) {
				         // 	console.log("REPLACE OLD ORDER BY NEW");
             //             this.orders[index2] = order;
             //            }	
				         

                        
                    }, (err) => {
                        if(this.loading){ this.loading.dismiss(); this.loading = undefined };
                        this.fireAlert(err.json().message);
                        console.log("not allowed");
                    }); 
 
          }
        }
      ]
    });
 
    prompt.present();
  }

  updateOrder(order:any, field:string){
  	let alert = this.alertCtrl.create();
    alert.setTitle('Change' + field + '?');

    if(field == 'status'){
    alert.addInput({type: 'radio', label: this.translate.instant('ORDER.STATUS.' + "10"), value: "10" });
    alert.addInput({type: 'radio', label: this.translate.instant('ORDER.STATUS.' + "50"), value: "50" });
    alert.addInput({type: 'radio', label: this.translate.instant('ORDER.STATUS.' + "60"), value: "60" });
    alert.addInput({type: 'radio', label: this.translate.instant('ORDER.STATUS.' + "70"), value: "70" });
    alert.addInput({type: 'radio', label: this.translate.instant('ORDER.STATUS.' + "71"), value: "71" });
    alert.addInput({type: 'radio', label: this.translate.instant('ORDER.STATUS.' + "100"), value: "100" });
    alert.addInput({type: 'radio', label: this.translate.instant('ORDER.STATUS.' + "500"), value: "500" });
	}

	if(field == 'internal_status'){
    alert.addInput({type: 'radio', label: this.translate.instant('ORDER.INTERNAL_STATUS.' + "10"), value: "10" });
    alert.addInput({type: 'radio', label: this.translate.instant('ORDER.INTERNAL_STATUS.' + "20"), value: "20" });
    alert.addInput({type: 'radio', label: this.translate.instant('ORDER.INTERNAL_STATUS.' + "100"), value: "100" });
	}

    alert.addButton('Cancel');
    alert.addButton({
      text: 'Update',
      handler: selected => {
        console.log('Selected Updates:', selected);

            this.orderService.updateOperatorOrder(order.id, field, selected).then((data: any) => {
		        console.log('DATAA from updateOperatorOrder:', data);
		        order.status = data.data.status;
		        order.internal_status = data.data.internal_status;
		        this.fireToast(data.message);
		    }, (err) => {

		        this.fireToast(err.json().message);
		        console.log("not allowed_____");
		        console.log(err);
		    });
        
        // for (let url of selected){
        // 	window.open(url, '_blank');
        // }
      }
    });
    alert.present();
  }

  operatorRejectImage(order:any, image:any){
 
    // let prompt = this.alertCtrl.create({
    //   title: "Image rejection",
    //   message: "Are you sure ?",
    //   buttons: [
    //     {
    //       text: "Cancel"
    //     },
    //     {
    //       text: "Reject",
    //       handler: rejection => {
 			// 	console.log("REJECTION:", rejection);
    //                 this.showLoader();
    //                 this.orderService.rejectOperatorImage(image).then((result: any) => {
    //                     if(this.loading){ this.loading.dismiss(); this.loading = undefined };
    //                     this.fireToast(result.message);

    //                     //Update locally
    //                     let image = result.data;
                        
                        
    //                      let index = order.images.findIndex(item => item.id == image.id);
    //                       console.log("INDEX OF IMAGE:", index);                       
				//             if(index > -1){
				//             	//Remove locally
				//                 //order.images.splice(index, 1);
				                
				//                 // Update locally
				//                 order.images[index] = image;
				                
				//             }     

				//          // Update order locally
				//          let index2 = this.orders.findIndex(item => item.id == order.id);
				//          console.log("INDEX of ORDER:", index2);
				//          if (index2 !== -1) {
				//          	console.log("REPLACE OLD ORDER BY NEW");
    //                      this.orders[index2] = order;
    //                     }	
				         
                        
                        
    //                     //let index = order.images.findIndex(item => item.id == image.id);
    //                     //let index = this.images.findIndex(item => item.id == image.id);
                        

                        
    //                 }, (err) => {
    //                     if(this.loading){ this.loading.dismiss(); this.loading = undefined };
    //                     this.fireAlert(err.json().message);
    //                     console.log("not allowed");
    //                 }); 
 
    //       }
    //     }
    //   ]
    // });
 
    // prompt.present();
 
  }

  // rejectImage(image){
 
  //   let prompt = this.alertCtrl.create({
  //     title: this.translate.instant("ORDER.REJECT_IMAGE_TITLE"),
  //     message: this.translate.instant("ORDER.REJECT_IMAGE_DESC"),
  //     inputs: [
  //       {
  //         name: 'disapproved_text'
  //       }
  //     ],
  //     buttons: [
  //       {
  //         text: this.translate.instant("BUTTONS.CANCEL")
  //       },
  //       {
  //         text: this.translate.instant("BUTTONS.SAVE"),
  //         handler: rejection => {
 
  //               if(rejection){
 
  //                   this.showLoader();
  //                   image.disapproved_text = rejection.disapproved_text;
  //                   this.orderService.rejectAdminImage(image).then((result: any) => {
  //                       if(this.loading){ this.loading.dismiss(); this.loading = undefined };
  //                       this.fireAlert(result.message);
  //                       console.log('Disapproval result', result);
  //                       //Update locally

                        
  //                   }, (err) => {
  //                       if(this.loading){ this.loading.dismiss(); this.loading = undefined };
  //                       this.fireAlert(err.json().message);
  //                       console.log("not allowed");
  //                   });
 
  //               }
 
 
  //         }
  //       }
  //     ]
  //   });
 
  //   prompt.present();
 
  // }


  changeUploadImageType(type, image, swatch){
    this.uploadImageType = type;
    console.log('SWATCH', swatch);
    if (swatch) {
      this.forImageId = image.id;
      this.imageSwatch = swatch;
    }else{
      this.forImageId = image.id;
    }
    console.log('this.uploadImageType', this.uploadImageType);
    console.log('this.forImageId', this.forImageId);
    console.log('this.image_swatch', this.imageSwatch);
  }

  showSimpleLoader(){
    this.loader = true;
  }

  closeSimpleLoader(){
    this.loader = false;
  }

  showLoader(){
 
    this.loading = this.loadingCtrl.create({
      content: 'Loading...'
    });
 
    this.loading.present();
 
  }
 
  logout(){
 
    this.authService.logout();
    this.navCtrl.setRoot('LoginPage');
 
  }

  open_help(type:string){
    if (type == 'free_image') {
      this.fireAlert('This image can be rejected with the reason "Too Difficult" if it is obvious that it is not a proper product photo. (Animals, People, Stock Photos, Sketches, Paintings)');
    }
  }

  fireToast(message: string) {
    console.log('fire toast!');
    let toast = this.toastCtrl.create({
                                    message: message,
                                    duration: 5000,
                                    position: 'top'
                                  });
                toast.present();
  }

  fireAlert(message: string) {
    let alert = this.alertCtrl.create({
                                    message: message,
                                    //duration: 2000,
                                    //position: 'bottom'
                                  });
    alert.present();
  }

  public fileOverBase(e: any, type:string, image:any, swatch:any): void {
        this.hasBaseDropZoneOver = e;

            this.uploadImageType = type;
            if (swatch) {
              this.forImageId = image.id;
              this.imageSwatch = swatch
            }else{
              this.forImageId = image.id;
            }
            console.log('this.uploadImageType', this.uploadImageType);
            console.log('this.forImageId', this.forImageId);
            console.log('this.image_swatch', this.imageSwatch);
  }

}




// WEBPACK FOOTER //
// ./src/pages/crm/crm.ts